import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import { Preamble, Title } from 'components/Misc/Typography';

const className = classnames(
	'py-2 px-3 flex flex-col space-y-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Article = ({ article }) => {
	return (
		<Link to={`/articles/${article.id}`} className={className}>
			<Title
				title={article.title}
				subtitle={DayJs(article.availableFrom || article.createdAt).format('D. MMM, YYYY')}
			/>

			<Show if={article.thumbnail}>
				<img
					alt={article.thumbnail}
					src={`${process.env.REACT_APP_CDN}/articles/${article.slug}/${article.thumbnail}`}
					className="mx-auto max-h-44 max-w-full rounded-lg"
				/>
			</Show>

			<Preamble value={article.description} className="font-normal text-neutral-700 dark:text-neutral-300" />
		</Link>
	);
};

export default Article;